import React from "react";
import { bool, string } from "prop-types";
import { DfpComponent } from "../../ads/dfp-component";
import { useSelector } from "react-redux";
import get from "lodash/get";
import Newsletter from "../../atoms/Newsletter";

import "./top-component-section-page.m.css";

export const AdSlot = ({ width, height, showNewsletter, rowAdDetails, id = "" }) => {
  const AdConfig300x250 = useSelector((state) =>
    get(state, ["qt", "config", "ads-config", "slots", "section_page_adslot_1"], {})
  );
  const AdConfig300x600 = useSelector((state) =>
    get(state, ["qt", "config", "ads-config", "slots", "section_page_adslot_1"], {})
  );
  if (!showNewsletter) {
    return (
      <div styleName="ad-slot">
        <DfpComponent
          adStyleName="ad-slot-size-300x600"
          id={id === "" ? `top-component-section-page-row-ad-300x600` : id}
          path={rowAdDetails}
          size={AdConfig300x600.sizes}
          viewPortSizeMapping={AdConfig300x600.view_port_size_mapping}
        />
      </div>
    );
  }

  return (
    <div styleName="newsletter-container">
      <div styleName="ad-slot-300x250">
        <DfpComponent
          adStyleName="ad-slot-size-300x250-constant"
          id={`top-component-section-page-row-ad-300x250`}
          path={rowAdDetails}
          size={AdConfig300x250.sizes}
          viewPortSizeMapping={AdConfig300x250.view_port_size_mapping}
        />
      </div>
      <Newsletter customStyle={{ margin: "16px 15px" }} />
    </div>
  );
};
AdSlot.propTypes = {
  width: string,
  height: string,
  showNewsletter: bool,
  rowAdDetails: string,
};

export const NativeAd = ({ showBorder }) => {
  const NativeAdConfig = useSelector((state) =>
    get(state, ["qt", "config", "ads-config", "slots", "top_comp_section_page_native_adslot"], {})
  );
  return (
    <div styleName="native-ad" style={{ border: showBorder || "none" }}>
      <div styleName="native-ad-box">
        <DfpComponent
          adStyleName="top-component-section-page-native-ad-slot"
          id={`top-component-section-page-native-ad`}
          path={NativeAdConfig.ad_unit}
          size={NativeAdConfig.sizes}
          containerStyle="top-component-section-page-native-ad-slot-container"
          isSponsored={true}
        />
      </div>
    </div>
  );
};

NativeAd.propTypes = {
  showBorder: bool,
};
